class DetailWidget {
    tabId: KnockoutObservable<number>;
    tabName: KnockoutObservable<string>;
    widgetId: KnockoutObservable<number>;
    widgetName: KnockoutObservable<string>;

    hasDetailing: KnockoutComputed<boolean>;

    
    constructor() {
        this.tabId = ko.observable(0);
        this.tabName = ko.observable("");
        this.widgetId = ko.observable(0);
        this.widgetName = ko.observable("");
        this.hasDetailing = ko.computed(function () {
            return this.tabId() !== 0 && this.widgetId() !== 0;
        }, this);
    }

    reset() {
        this.tabId(0);
        this.tabName("");
        this.widgetId(0);
        this.widgetName("");
        this.setSubmitValues = false;
    }

    /**'GetTab' is used to draw for the first time and update data, so we need to set the tab details only the first time, otherwise it will always detail the tab and reset the filters that the user modified.*/
    setSubmitValues = false;
    setSubmitObj(submitOjb, tab: WorkbookTab) {
        if (this.setSubmitValues) {
            return;
        }

        submitOjb.fromTabDetail = this.tabId();
        submitOjb.fromTabDetailWidget = this.widgetId();
        submitOjb.loadFilters = true;
        tab.filters([]);//clear filters before loading to improve user perception

        let dashboardTab = workbook.workbookConfig.tabs().find(x => x.id() === this.tabId());
        if (dashboardTab) {
            let dashboardWidget = dashboardTab.dashboard.widgets().find(x => x.id() === this.widgetId());
            if (dashboardWidget && dashboardWidget.widgetType() === WidgetType.KPI) {
                let kpiConfig = dashboardWidget.itemConfig() as KPIConfig;
                if (kpiConfig && kpiConfig.useLastPeriod() && kpiConfig.trendAxisField()) {
                    submitOjb.filterFieldId = kpiConfig.trendAxisField();
                    submitOjb.filterFieldAutoGrouping = kpiConfig.trendAxisFieldAutoGrouping();
                    let kpiResult = dashboardWidget.widget.result as KPIWidgetResultVM;
                    if (kpiResult && kpiResult.trendValues.length) {
                        submitOjb.filterValue = kpiResult.trendValues[kpiResult.trendValues.length - 1].axisValue;
                    }
                }
            }
        }

        this.setSubmitValues = true;
    }
}